import { Component, Input } from '@angular/core';
import { SortDirection, SortEvent } from '@aposin/ng-aquila/table';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-claim-details-table',
  standalone: true,
  imports: [
    SharedModule
  ],
  templateUrl: './claim-details-table.component.html',
  styleUrl: './claim-details-table.component.scss'
})
export class ClaimDetailsTableComponent {
  @Input() data;

  async sortTable(sort: SortEvent, tableName: string) {
    let abc = this[tableName];
    this[tableName] = await abc.slice().sort((current, previous) => {
      return this.compare(current[sort.active], previous[sort.active], sort.direction);
    });
  }

  compare(a, b, direction: SortDirection) {
    const isEmpty = v => v === null || v === undefined || v === '';

    if((isEmpty(a) && isEmpty(b)) || (a == b)) {
      return 0;
    }

    if(isEmpty(a)) {
      return direction === 'asc' ? -1 : 1;
    }

    if(isEmpty(b)) {
      return direction === 'asc' ? 1 : -1;
    }

    return (a < b ? -1 : 1) * (direction === 'asc' ? 1 : -1);
  }
  
}
